export default {"src":"/_next/static/media/edgy_close_icon.9e369fe6.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};